export const digitsOnly = /^\d*$/;
export const windowsRegex = /^[A-Za-z]:\\(?:[\w\s\(\)]+\\)*(?:\*.\*|[\w\s-]+)?$/
export const linuxRegex = /^\/(?:[\w-]+\/)*[\w-]+\/?$/;
export const datalakeUrlPattern = /^(https?:\/\/)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/;
export const textPattern = /^[a-zA-Z0-9\s()"'._\-,:;@[\]\/\\]*$/;
export const suppliesValueSeparator = /,\s*(?=[A-Za-z][A-Za-z ]*?\s*:)/;
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9 \-_]*$/;

